
/**
 * Generate appropriate response message based on product creation results
 * @param added Number of added products
 * @param updated Number of updated products
 * @param total Total number of products processed
 * @returns Formatted message describing the operation results
 */
export const getProductUploadResponseMessage = (added: number, updated: number, total: number) => {
  const skipped = total - added - updated;
  
  if (added === 0 && updated === 0) {
    return 'All products already exist in the database with the same units.';
  }
  
  let message = '';
  if (added > 0) {
    message += `Successfully added ${added} new products. `;
  }
  if (updated > 0) {
    message += `Updated units for ${updated} existing products. `;
  }
  if (skipped > 0) {
    message += `${skipped} products were skipped as they already exist with same units.`;
  }
  
  return message.trim();
};
